export const removeInstitutionTags = (tags) => {
    let filteredTags = tags.filter( tag => tag.type != "Institución")
    return filteredTags
 }